import React from "react";
import styled from "styled-components";
import AccomCube from "../SubComponents/AccomCube";
import Button from "../SubComponents/Button";

import Navbar from "../SubComponents/Navbar";
import EventCube from '../SubComponents/EventCube'

const Section = styled.div`
  width: 100vw;
  min-height: 100vh;
  background-color: rgba(32, 32, 32, 0.3);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
`;

const Heading = styled.div`
  width: 80%;
  height: auto;
  padding: 1rem;
  margin: 1rem;
  margin-bottom: 2rem;
  font-size: 1.2rem;
  text-align: center;
  /* border: 1px solid black; */
`;

const Accomo = styled.div`
  width: 80%;
  height: 60vh;
  position: relative;
  margin-bottom: 1rem;

  display: flex;
  flex-direction: row;
  align-items: center;

  /* border: 2px solid green; */
  /* justify-content: space-between; */
  /* padding: 1rem; */
`;

const Details = styled.div`
  width: 65%;
  height: 100%;
  position: absolute;
  left: 35%;
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  justify-content: center;
  /* align-items: center; */
  padding: 0 1rem;
  box-sizing: border-box;
  /* margin-right: 1rem; */
  /* border: 1px solid yellow; */

  p {
    font-size: 1.2rem;
    font-weight: 500;
  }

  a {
    font-size: 1rem;
    font-weight: 400;
  }
`;

const Event = styled.div`
  width: 90%;
  height: 55vh;
  /* border: 2px solid green; */
  position: relative;

  display: flex;
  flex-direction: row;
  align-items: center;
`;

const EventDetails = styled.div`
  width: 65%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 1rem;
  box-sizing: border-box;
  /* border: 1px solid yellow; */
  margin-left: 4rem;

  p {
    font-size: 1.2rem;
    font-weight: 500;
  }

  a {
    font-size: 1rem;
    font-weight: 400;
  }
`;

const Explore = () => {
  return (
    <>
      <Navbar />
      <Section>
        <Heading>
          Beaches offer beautiful nature, sight and relaxation on long beaches, as well as breathtaking views which might even surprise you. You can relax and enjoy the lovely views and experience more activities on the beach 
        </Heading>
        <Accomo>
          <AccomCube />
          <Details>
            <p>
              We are here for you if u are looking for houses and hotels near beaches. Take a look at these colorful wooden houses, lovely compact design, average area from 8-12 meter sqr, basic amenities including air-conditioner, toiler, suitable for overnight stay. 
            </p>
            <Button text="Discover More ->" link="/accomodations" />
          </Details>
        </Accomo>
        <Event>
          <EventDetails>
          <p>
          Temporarily put aside the chaos of the city for a few days, come to beaches to chill and immerse yourself in music. Look for events, parties and concerts happening on beaches and enjoy the golden sunshine, blue sea and white sand.
          </p>
          <Button text="Discover More ->" link="/events" />
          </EventDetails>
          <EventCube/>
        </Event>
      </Section>
    </>
  );
};

export default Explore;
